import { createContext } from 'react'

import type { AllergyIntolerance, AllergyProfileStatus } from '@/modules/app/types/HealthParameter.types'

/**
 * An {@link AllergyIntolerance} extended with a client-only identifier for
 * stable identity in the UI (React keys, delete targeting).
 *
 * The `_clientId` is never written to Formik so it cannot reach the API.
 */
export type IdentifiedAllergyIntolerance = AllergyIntolerance & {
  _clientId: string
}

/**
 * Shared state for the {@link AllergyQuestion} compound component.
 *
 * Provided by `AllergyQuestion` and consumed by its sub-components
 * (`AllergyDialogContent`) so they can read and mutate the allergy
 * list without prop drilling.
 */
export type AllergyContextValue = {
  questionId: string
  allergies: IdentifiedAllergyIntolerance[]
  schemeStatus: AllergyProfileStatus
  addAllergy: (allergy: AllergyIntolerance) => void
  editAllergy: (id: string, allergy: AllergyIntolerance) => void
  removeAllergy: (id: string) => void
  confirmNoAllergies: () => void
  setView: (view: 'choice' | 'form') => void
  onSubmitAndAdvance: () => void
}

export const AllergyContext = createContext<AllergyContextValue | null>(null)
